import Button from "@material-ui/core/Button";
import React from "react";
import { makeStyles } from "@material-ui/core";
import AutorenewIcon from "@material-ui/icons/Autorenew";

interface ISwitchModeButton {
  isMapView: boolean;
  setIsMapView: any;
}

const useStyles = makeStyles({
  root: {
    float: "right",
    padding: "4px 16px",
  },
});

const SwitchModeButton = ({ isMapView, setIsMapView }: ISwitchModeButton) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.root}
      color="primary"
      variant="contained"
      onClick={() => setIsMapView(!isMapView)}
      startIcon={<AutorenewIcon />}
    >
      {isMapView ? "List View" : "Map View"}
    </Button>
  );
};

export default SwitchModeButton;
